import React from "react";

const ProgressBar = ({progress}) => {
  return (
    <div className="progress-bar__container">
        <div className="progress-bar__container-box"  style={{width: `${progress}`+'%', backgroundColor: '#455CC7'}}>
            {/* <span className="progress-bar__container-box__quant">
                {`${progress}%`}
            </span> */}
        </div>
    </div>
  );
};

export default ProgressBar;
